export enum FieldTypeEnum {
  Integer,
  Bool,
  String,
  Date,
  Decimal,
}
